import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const McdInvLineList = ({ mcdInv, isCld }) => {
  
  /** Fields excluded when filtering by lineLevel*/
  const EXCLUDED_FIELDS = {
    SUM: [
      'linkedIcn',
      'rxNum',
      'extLineIdent',
      'extLineIdentType',
      'fillNum',
      'svcDate',
      'reimbDate',
      'extPharmNpi',
      'extPharmType',
      'pharmCust',
      'pharmCustName',
      'extPrescrNpi',
      'copayPaid',
      'premiumPaid',
      'phs340bFlag',
      'extReversalFlag',
      'coverageType',
      'extCmsUnitType',
      'daysSupply'
    ],

    CLD: [
      'invAmt',
      'dispUnits',
      'dispAmt',
      'paidUnits',
      'paidAmt',
      'dueUnits',
      'dueAmt'
    ]
  }

  const augRowsReq = useCallback((rowsReq) => {
    if (!mcdInv) {
      return;
    }

    let lineLevel = isCld ? 'CLD' : 'SUM';
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('invPeriodId', mcdInv.invPeriodId, 'mcdInvId', mcdInv.id, 'lineLevel', lineLevel));
  }, []);

  const augFieldDefs = useCallback((fieldToFieldDef) => {
    let lineLevel = isCld ? 'CLD' : 'SUM';
    let excludedFields = EXCLUDED_FIELDS[lineLevel];
    excludedFields.forEach(hiddenField => {
        let fieldDef = fieldToFieldDef?.[hiddenField]
        if (fieldDef) {
          fieldDef.hide = true;
        }
      }
    )

    // 1. Dimensions
    fieldToFieldDef.stateId.precedence = 0;
    fieldToFieldDef.stateId.hasName = false;

    fieldToFieldDef.invPeriodId.precedence = 3;
    fieldToFieldDef.invPeriodId.hasName = false;

    fieldToFieldDef.rbtPeriodId.precedence = 4;
    fieldToFieldDef.rbtPeriodId.hasName = false;

    fieldToFieldDef.prodId.precedence = 5;
    fieldToFieldDef.prodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Units
    fieldToFieldDef.invUnits.precedence = 2000;
    fieldToFieldDef.incrInvUnits.precedence = 2000;
    fieldToFieldDef.incrDispUnits.precedence = 2001;
    fieldToFieldDef.incrDueUnits.precedence = 2002;
    fieldToFieldDef.incrPaidUnits.precedence = 2003;

    // 4. URAs
    fieldToFieldDef.invUra.precedence = 3000;
    fieldToFieldDef.calcUra.precedence = 3001;

    // 5. Amounts
    fieldToFieldDef.extInvAmt.precedence = 4000;
    fieldToFieldDef.invAmt.precedence = 4001;
    fieldToFieldDef.incrInvAmt.precedence = 4002;
    fieldToFieldDef.incrDispAmt.precedence = 4003;
    fieldToFieldDef.incrDueAmt.precedence = 4004;
    fieldToFieldDef.incrPaidAmt.precedence = 4005;
  }, []);

  return (
    <EntityList entity="MCD_INV_LINE" augRowsReq={augRowsReq} augFieldDefs={augFieldDefs} />
  )
}